import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'

export const mapExpertDomainDataToTableRow = ({
  id,
  name,
  email,
  hasAcceptedTerms,
}: ExpertDomain) => ({
  id,
  name,
  email,
  status: hasAcceptedTerms ? 'Aceito' : 'Pendente',
  actions: null,
})
